export default __webpack_public_path__ + "media/images/deroulant2-17621c003ab3c4376d4b2689d0883e4a.png";